<template>
    <button type="button" class="relative rounded-full p-1 border-2 text-gray-500 hover:text-gray-400">
        <slot/>
        <span class="absolute top-0 right-0 inline-block w-2 h-2 transform translate-x-0.5 bg-eaze-blue rounded-full"></span>
    </button>
</template>

<script setup>

</script>